export class ProductPriceAdjustments {
  Id?: number;
  AdjustmentType?: number;
  ProductId?: number;
  Origin?: string;
  Price?: number;
  Discount?: number;
  Points?: number;
  pointType?: string;
  CreatedBy?: string;
  CreatedDate?: Date;
  UpdatedBy?: string;
  UpdatedDate?: Date;
}
